<template>
    <div>
        
        <PageHeader :page_title="page_title"/>
        <pSpinner v-if="loading"></pSpinner>
        <template v-if="!loading">
            <v-tabs  v-model="active_tab1" color="grey  lighten-3" dark  slider-color = "primary" >
                <v-tab ripple class = "black--text ml-4" v-for="tab of tabs"  :key="tab.id"  @click="redirectTo(tab.id,tab.link)" >
                    {{tab.name}}
                </v-tab>
            </v-tabs>
            <div :class="{'ml-4': $vuetify.breakpoint.mdAndUp,'mr-4': $vuetify.breakpoint.mdAndUp,'ml-3': $vuetify.breakpoint.smAndDown,'mr-3': $vuetify.breakpoint.smAndDown,}" >
            <v-alert :value="alert" class="cyb-alert-info mt-3 mb-0 pb-0"  >{{alert_message}}<v-icon  @click = "alert = false" style="padding-bottom: 8px;float: right;font-size: 19.5px;font-weight: bold;line-height: 1;"  class="close_hover" >close</v-icon></v-alert> 
            </div>
            <v-container fluid>
                <template>
                    <v-data-table   hide-actions  :items="installment_schedule_data" select-all item-key="id" class="elevation-1"   style="margin-bottom: 3rem;width: 100%;">
                        <template slot="headers" slot-scope="props">
                            <tr bordercolor="red" style="background-color:#eceff1;">
                            <th class = "header-style" style="text-align:left;color: black;font-size: 14px;">Installment No</th>
                            <th class = "header-style" style="text-align:right;color: black;font-size: 14px;">Installment Amount</th>
                            <th class = "header-style" style="text-align:right;color: black;font-size: 14px;">Paid Amount</th>
                            <th class = "header-style" style="text-align:right;color: black;font-size: 14px;">Balance Amount</th>
                            <th class = "header-style" style="text-align:left;color: black;font-size: 14px;">Due Date</th>
                            </tr>
                           
                        </template>
                        
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td v-if="props.item.instalment_no =='Total'" class="text-xs-left"><b>{{ props.item.instalment_no }}</b></td><td v-else="props.item.instalment_no =='Total'" class="text-xs-left">{{ props.item.instalment_no }}</td>
                                <td v-if="props.item.instalment_no =='Total'" class="text-xs-right"><b>{{ props.item.instalment_amount }}</b></td><td v-else="props.item.instalment_no =='Total'" class="text-xs-right">{{ props.item.instalment_amount }}</td>
                                <td v-if="props.item.instalment_no =='Total'" class="text-xs-right"><b>{{ props.item.paid_amount }}</b></td><td v-else="props.item.instalment_no =='Total'" class="text-xs-right">{{ props.item.paid_amount }}</td>
                                <td v-if="props.item.instalment_no =='Total'" class="text-xs-right"><b>{{ props.item.balance_amount }}</b></td><td v-else="props.item.instalment_no =='Total'" class="text-xs-right">{{ props.item.balance_amount }}</td>
                                <td v-if="props.item.instalment_no =='Total'" class="text-xs-left"><b>{{ props.item.due_date_in_date }}</b></td><td v-else="props.item.instalment_no =='Total'" class="text-xs-left">{{ props.item.due_date_in_date }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </template>
            </v-container>
        </template>
        
    </div>

</template>

<script>

import axios from 'axios'

import NoData from '@/components/NoData'

import pSpinner from '@/components/pSpinner';

import global from '@/components/rbconstants';

import PageHeader from '@/components/PageHeader'
  
  

export default {

    components : {

        NoData : NoData,
        
        PageHeader : PageHeader,
        
        pSpinner : pSpinner,

    },  
    
    mounted() {
        
        this.getDataFromApi()
        
        .then(data => {
            
            this.installment_schedule_data = data.installment_schedule.rd_chart;
            
            this.dues = data.installment_schedule.dues;
         
            if(this.dues.type == true) {
            
                this.alert = true
                
                this.alert_message = this.dues.message
                
            } else {
                
                this.alert = false 
                
            }

            
            this.loading = false;
        })
        
    },
      
    data: () => ({
        
        page_title : "Recurring Deposit Installment Schedule - ",
        
        installment_schedule_data : [],
        
        table1_headers : [{ text: '#'}, { text : 'Vou. ID'}, { text : 'Date'}, { text : 'Narration'}, { text : 'Debit'},
                         { text : 'Credit'}, { text : 'Principal Balance'}],
        
        active_tab1: 2,
        
        dues: [],
        
        alert_message: '',
        
        
        tabs: [
            
            { id: 1, name: "Account Details", route: "deposits/recurring/:id" },
            { id: 2, name: "Ledger", route: "deposits/recurring/:id/ledger" },
            { id: 3, name: "Installment Schedule", route: "deposits/recurring/:id/installment-schedule" }
            
          ],
          
        alert : false,
        
          
        loading : false
    }),
    
	methods : {
	    
        getDataFromApi() {
            
            this.loading = true;
            
            this.table_loading = true
            
            return new Promise((resolve, reject) => {
            
                var app = this;
                
                var form_post_data = {};
                
                var link = global.links.recurring_deposit_installment_schedule;
                
                var deposit_id = this.$route.params.id
                
                link = link.replace(':id',deposit_id);
                
                axios.post(link, {
                
                    params : form_post_data,
                
                }, { headers : global.header })
                
                .then(function (response) {
                
                    if(response.status == 200) {
                        
                        var installment_schedule = response.data.data;
                        
                        app.page_title += response.data.data.account_id
                        
                        document.title = 'Recurring Deposit Installment Schedule '+response.data.data.account_id+' - '+global.app_name

                        setTimeout(() => {
                            
                            app.table_loading = false
                            
                            app.loading = false;
                            
                            resolve({
                                
                                installment_schedule
                            
                            })
                        
                        }, 1000)
                    
                    }
                    
                }) .catch(function (error) {
                    
                    if(error.response.data.error.code == 400) {
              
                      app.$router.push({ name: 'DepositList',  params: { alert: true}})
        
                    }
                
                    app.loading = false;
                
                });
            
            });
            
        },
        
        redirectTo(id, link) {
        
            if(id == 1) {
            
                var id = this.$route.params.id;
                
                this.$router.push({ name: 'RecurringDeposit', params: { id: id}});
            
            } else if(id == 2) {
            
                var id = this.$route.params.id;
                
                this.$router.push({ name: 'RecurringDepositLedger', params: { id: id}});
                
            } else if(id == 3) {
            
                var id = this.$route.params.id;
                
                this.$router.push({ name: 'RecurringDepositInstallmentSchedule', params: { id: id}});
            
            }
        
        }
        
	},
	
}
  
</script>
<style scoped>

    .cyb-alert-info {
        color: #5e583f  !important; 
        border: 1px solid #ebccd1 !important;
        border-radius: 4px !important;
        background-color: #fef1a8 !important;
        border-color: #ffdb73 !important;
        /*margin-left: 20px !important;*/
        /*margin-right: 20px !important;*/
        /*padding-left: 16px !important;*/
        padding-top: 8px !important;
        padding-bottom: 2px !important;
        margin-bottom: -7px !important;
    }
    
        
    .close_hover{ color: 	#808080 !important;}
    
    .close_hover:hover {color: rgba(0,0,0,0.87) !important;}

</style>
